var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7238_8027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6027 9.55211L9.18848 10.9663L13.1859 14.9638L14.6001 13.5496L10.6027 9.55211Z",
    fill: "#FFD874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 7.51826C12.9532 7.51826 13.9999 6.47159 13.9999 5.18493C13.9999 4.79826 13.8932 4.43826 13.7266 4.11826L11.9266 5.91826L10.9332 4.92493L12.7332 3.12493C12.4132 2.95826 12.0532 2.8516 11.6666 2.8516C10.3799 2.8516 9.33324 3.89826 9.33324 5.18493C9.33324 5.45826 9.38657 5.71826 9.47324 5.95826L8.2399 7.19159L7.05324 6.00493L7.52657 5.53159L6.58657 4.5916L7.9999 3.17826C7.2199 2.39826 5.95324 2.39826 5.17324 3.17826L2.81324 5.53826L3.75324 6.47826H1.87324L1.3999 6.95159L3.7599 9.31159L4.23324 8.83826V6.95159L5.17324 7.89159L5.64657 7.41826L6.83324 8.60493L1.89324 13.5449L3.30657 14.9583L10.8932 7.37826C11.1332 7.46493 11.3932 7.51826 11.6666 7.51826Z",
    fill: "#FFD874"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7238_8027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.851562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.89c013c3e524aa96e3db3533d5f9c6c5.svg";
export { ForwardRef as ReactComponent };